var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserResource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.653 25H7.551A1.553 1.553 0 016 23.444v-3.888a3.097 3.097 0 012.72-3.073c-.706-.701-1.169-1.784-1.169-2.717A2.762 2.762 0 0110.31 11c1.32 0 2.42.932 2.691 2.175a4.669 4.669 0 00-2.345 4.01h-.002V25zm16.626-8.517A3.098 3.098 0 0130 19.556v3.888c0 .86-.694 1.556-1.551 1.556h-3.103V17.186h-.001A4.669 4.669 0 0023 13.176 2.758 2.758 0 0125.691 11a2.762 2.762 0 012.758 2.766c0 .934-.463 2.016-1.17 2.717zM12 17.231c0-1.7 1.343-3.077 3-3.077h1.322a4.157 4.157 0 01-.612-.77 4.812 4.812 0 01-.389-.769A4.21 4.21 0 0115 11.077C15 9.377 16.343 8 18 8s3 1.378 3 3.077a4.21 4.21 0 01-.321 1.538 4.812 4.812 0 01-.39.77 4.157 4.157 0 01-.611.769H21c1.657 0 3 1.378 3 3.077v9.23c0 .85-.671 1.539-1.5 1.539h-9c-.829 0-1.5-.688-1.5-1.538V17.23z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#7B98B6",
    xlinkHref: "#a",
    transform: "translate(-6 -8)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserResource);
export default __webpack_public_path__ + "static/media/UserResource.874012309dcd6177559847eb63b945ae.svg";
export { ForwardRef as ReactComponent };